import script from "./AssetLibraryPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetLibraryPreview.vue?vue&type=script&setup=true&lang=js"

import "./AssetLibraryPreview.vue?vue&type=style&index=0&id=3f592bf6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f592bf6"]])

export default __exports__